import React from "react";
import "./Process.css";
import icon1 from '../../images/process/icon1.png';
import icon2 from '../../images/process/icon2.png';
import icon3 from '../../images/process/icon3.png';
import icon4 from '../../images/process/icon4.png';
import icon5 from '../../images/process/icon5.png';
import icon6 from '../../images/process/icon6.png';

const steps = [
  { id: 1, img: icon1, label: "Discover" },
  { id: 2, img: icon3, label: "Design"   },
  { id: 3, img: icon4, label: "Build"    },
  { id: 4, img: icon5, label: "Validate" },
  { id: 5, img: icon2, label: "Deploy"   },
  { id: 6, img: icon6, label: "Optimize" },
];

export default function Process() {
  return (
    <section className="process-section" id="process">
      <div className="container-fluid px-5">
        <p className="process-intro">
          Our delivery model aligns business priorities, architecture, implementation, and measurable outcomes through a phased, accountable approach.
        </p>

        <div className="process-row">
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              {/* Step */}
              <div className="proc-step">
                <div className="proc-icon">
                  <img src={step.img} alt={step.label} className="proc-icon-img" />
                </div>
                <span className="proc-label">{step.label}</span>
              </div>

              {/* Connector — not after last */}
              {index < steps.length - 1 && (
                <div className="proc-connector">
                  <span className="proc-dot" />
                  <span className="proc-line" />
                  <span className="proc-dot" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}